import React from 'react';
import { Grid, Card, CardContent, Typography, Chip, Box, Skeleton } from '@mui/material';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import NumbersIcon from '@mui/icons-material/Numbers';

const ACCOUNT_COLORS = {
  USER_ESCROW: '#1976d2',
  ASTROLOGER_WITHDRAWABLE: '#388e3c',
  PLATFORM_REVENUE: '#7b1fa2',
  GATEWAY_RECEIVED: '#f57c00',
  PAYOUT_PENDING: '#0288d1',
  SUSPENSE: '#d32f2f',
};

const formatPaise = (paise) => {
  if (paise == null) return '₹0';
  return `₹${(paise / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

const LedgerSummaryCards = ({ dashboard, loading }) => {
  if (loading) {
    return (
      <Grid container spacing={2}>
        {[1, 2, 3, 4].map((i) => (
          <Grid item xs={12} sm={6} md={3} key={i}>
            <Skeleton variant="rectangular" height={120} sx={{ borderRadius: 2 }} />
          </Grid>
        ))}
      </Grid>
    );
  }

  if (!dashboard) return null;

  const statCards = [
    { label: 'Total Entries', value: dashboard.total_entries?.toLocaleString() || '0', icon: <ReceiptLongIcon /> },
    { label: 'Total Journals', value: dashboard.total_journals?.toLocaleString() || '0', icon: <AccountBalanceIcon /> },
    { label: 'Last Sequence #', value: dashboard.last_entry_sequence?.toLocaleString() || '0', icon: <NumbersIcon /> },
  ];

  return (
    <Box>
      <Grid container spacing={2} sx={{ mb: 3 }}>
        {statCards.map((card) => (
          <Grid item xs={12} sm={4} key={card.label}>
            <Card elevation={2}>
              <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box sx={{ color: 'primary.main' }}>{card.icon}</Box>
                <Box>
                  <Typography variant="body2" color="text.secondary">{card.label}</Typography>
                  <Typography variant="h5" fontWeight="bold">{card.value}</Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Account balance chips */}
      <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>Account Balances (Ledger-Derived)</Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {(dashboard.account_balances || []).map((bal) => (
          <Chip
            key={`${bal.account_type}-${bal.owner_type}`}
            label={
              <Box>
                <Typography variant="caption" display="block" sx={{ lineHeight: 1.2 }}>
                  {bal.account_type}
                </Typography>
                <Typography variant="body2" fontWeight="bold">
                  {formatPaise(bal.balance_paise)}
                </Typography>
              </Box>
            }
            sx={{
              height: 'auto',
              py: 0.5,
              bgcolor: ACCOUNT_COLORS[bal.account_type] || '#616161',
              color: 'white',
              '& .MuiChip-label': { display: 'block', whiteSpace: 'normal' },
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default LedgerSummaryCards;
